import React, { useRef, useState, useEffect, useMemo } from "react";

import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import {
    Box,
    Tooltip
} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Paper from '@mui/material/Paper';

import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem, useMediaQuery
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ReactApexChart from 'react-apexcharts';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import api from '../../../../../services/api.js';
import NavegadorGestao from "../../../../../components/NavBarGestao/index.js";
import moment from 'moment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';

import { parseISO } from 'date-fns';

import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';

import { Card, CardContent, Typography, Collapse } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';

import { Button } from "@material-ui/core";
import MetodosPagamento from '../MetodosPagamento/index';
import CondicoesPagamento from '../CondicoesPagamento/index';
import InstituicaoBancaria from '../InstituicaoBancaria/index';
import GrupoContas from '../GrupoContas/index';
import Contas from '../Contas/index';
import Taxas from '../Taxas/index';
import FluxoCaixa from '../FluxoCaixa/index';
import Parcelas from '../Parcelas/index';
import { useTheme } from "@mui/material/styles";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import GerenciarInstituicaoBancaria from '../InstituicaoBancaria/gerenciar.js';
import Lancamentos from '../Lancamentos/index';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DashboardGeral from './DashboardGeral'


const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function Financeiro() {
    
    const regra = Cookies.get('regra') || '';
  
    const [value, setValue] = useState(() => {
        console.log("Regra: " + regra);
        
        if (regra.includes("SUPER_ADMIN") ||
            (regra.includes("ADMIN_CONTAS_A_PAGAR") && regra.includes("ADMIN_CONTAS_A_RECEBER"))) {
           console.log("Regra: tudo" );
        
                return 1; // Visão Geral
        } else if (regra.includes("ADMIN_CONTAS_A_PAGAR")) {
                       console.log("Regra: conta a pagar");

            return 12; // Contas a Pagar
        } else if (regra.includes("ADMIN_CONTAS_A_RECEBER")) {
               console.log("Regra: conta a receber");

            return 11; // Contas a Receber
        } else {
             console.log("Regra: nenhuma");

            return -1; // Nenhuma permissão válida
        }



    });



    const theme = useTheme();

    const [open, setOpen] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };


    const [openLancamentos, setOpenLancamentos] = useState(false);

    const handleLancamentosClick = () => {
        setOpenLancamentos(!openLancamentos);
    };

    const [anchorEl2, setAnchorEl2] = useState(null);
    const open2 = Boolean(anchorEl2);


    const [instituicaoBancariaGerenciar, setInstituicaoBancariaGerenciar] = useState(null);


    const handleSetInstituicaoBancariaAtualizar = (ib) => {
        setInstituicaoBancariaGerenciar(ib);
        setValue(100);
    }


    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // mobile até sm


    const handleClickAux = (event) => {
        setAnchorEl2(event.currentTarget);
    };


    const [openAux, setOpenAux] = useState(false);

    const handleAuxClick = () => {
        setOpenAux(!openAux);
    };


    const handleClose2 = () => {
        setAnchorEl2(null);
    };

    const [loading, setLoading] = useState(true);








    const [reloadKey, setReloadKey] = useState(0);

    const [totalRegistros, setTotalRegistros] = useState(0);

    const [filtro, setFiltro] = useState('');





    const [totalDespesas, setTotalDespesas] = useState(0.0);
    const [totalReceitas, setTotalReceitas] = useState(0.0);

    const [totalDespesasMesAtual, setTotalDespesasMesAtual] = useState(0.0);
    const [totalDespesasPagoMesAtual, setTotalDespesasPagoMesAtual] = useState(0.0);
    const [totalDespesasAPagarMesAtual, setTotalDespesasAPagarMesAtual] = useState(0.0);


    const [totalDespesasHoje, setTotalDespesasHoje] = useState(0.0);
    const [totalReceitasHoje, setTotalReceitasHoje] = useState(0.0);


    const [totalReceitasMesAtual, setTotalReceitasMesAtual] = useState(0.0);
    const [totalReceitasPagoMesAtual, setTotalReceitasPagoMesAtual] = useState(0.0);
    const [totalReceitasAPagarMesAtual, setTotalReceitasAPagarMesAtual] = useState(0.0);



    const dataAtual = new Date();
    const mesAtual = dataAtual.toLocaleString('default', { month: 'long' });
    const anoAtual = dataAtual.getFullYear();



    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });



    const [dadosGrafico, setDadosGrafico] = useState({
        series: [
            { name: 'Receitas', data: [] },
            { name: 'Despesas', data: [] },


        ],
        options: {
            chart: {
                height: '100%',
                type: 'bar',
                width: '100%',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '100%',
                    endingShape: 'rounded'

                },
            },
            colors: ['#0288d1', '#6a1b9a'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: [],
            },
            yaxis: {
                title: {
                    text: 'Valores',
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return currencyFormatter.format(val);
                    }
                }
            }
        }
    });






    function novo() {
        window.location.href = "/gestao/financas/lancamento/cadastrar"

    }





    const handleMenuClick = (newValue) => {
        setReloadKey(prev => prev + 1);
        if (newValue === 0) {
            //   listarInfoDashboard();
        } else if (newValue === 1) {

            //  listarLancamentos();
        } else if (newValue === 2) {


        } else if (newValue === 10) {

        }

        setValue(newValue);
        setAnchorEl2(null);
    };


    return (
        <div>

            <NavegadorGestao
                Financas={true}
                Lancamentos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />


            {/* Botão hamburger mobile chamativo */}
            {isMobile && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mt: 1,
                        mb: 1,
                        px: 2,
                    }}
                >
                    <IconButton
                        onClick={toggleDrawer}
                        sx={{
                            bgcolor: '#48D1CC',
                            color: 'white',
                            '&:hover': { bgcolor: '#20B2AA' },
                            width: 50,
                            height: 50,
                            borderRadius: 2,
                        }}
                    >
                        <MenuIcon fontSize="large" />
                    </IconButton>
                </Box>
            )}

            {regra && value > -1 && (
                <>

                    {value === 0 &&
                        regra.includes("ADMIN_CONTAS_A_RECEBER") && regra.includes("ADMIN_CONTAS_A_PAGAR")
                        &&
                        (
                            <div
                                style={{
                                    paddingTop: 5,
                                    paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                    width: '100%',
                                }}

                            >
                                <DashboardGeral />


                            </div>
                        )}

                    {value === 1 &&
                        ((regra.includes("ADMIN_CONTAS_A_RECEBER") && regra.includes("ADMIN_CONTAS_A_PAGAR"))
                        ) &&
                        (
                            <div
                                style={{
                                    paddingTop: 5,
                                    paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                    width: '100%',
                                }}

                            >
                                <Lancamentos key={reloadKey} titulo={"Visão Geral"} flag={2} />


                            </div>
                        )}


                    {value === 11 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <Lancamentos key={reloadKey} titulo={"Contas a Receber"} flag={1} />


                        </div>
                    )}


                    {value === 12 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <Lancamentos key={reloadKey} titulo={"Contas a Pagar"} flag={0} />


                        </div>
                    )}




                    {value === 2 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <FluxoCaixa key={reloadKey} />


                        </div>
                    )}


                    {value === 3 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <Parcelas key={reloadKey} />


                        </div>
                    )}



                    {value === 10 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <MetodosPagamento key={reloadKey} />


                        </div>
                    )}




                    {value === 20 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <CondicoesPagamento key={reloadKey} />


                        </div>
                    )}



                    {value === 30 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <GrupoContas key={reloadKey} />


                        </div>
                    )}


                    {value === 40 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >
                            <Contas key={reloadKey} />


                        </div>
                    )}



                    {value === 50 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >

                            <InstituicaoBancaria key={reloadKey}
                                handleSetInstituicaoBancariaAtualizar={handleSetInstituicaoBancariaAtualizar}
                            />


                        </div>
                    )}



                    {value === 100 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >


                            <GerenciarInstituicaoBancaria key={reloadKey}
                                instituicaoBancaria={instituicaoBancariaGerenciar}
                            />


                        </div>
                    )}


                    {value === 60 && (
                        <div
                            style={{
                                paddingTop: 5,
                                paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                                width: '100%',
                            }}

                        >


                            <Taxas key={reloadKey} />

                        </div>
                    )}

                </>)}



            <Drawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={open}
                onClose={toggleDrawer}
                anchor="left"
                sx={{
                    '& .MuiDrawer-paper': {
                        top: isMobile ? 0 : '80px',
                        height: isMobile ? '100vh' : 'calc(100vh - 100px)',
                        width: open ? 230 : 50,
                        transition: 'width 0.3s',
                        overflowX: 'hidden',
                        bgcolor: '#f0f8ff',
                    },
                }}
            >


                {!isMobile && (
                    <IconButton onClick={toggleDrawer} sx={{ alignSelf: 'flex-end', m: 1 }}>
                        {open ? <ChevronLeftIcon sx={{ color: '#1976d2' }} /> : <ChevronRightIcon sx={{ color: '#1976d2' }} />}
                    </IconButton>
                )}


                <List>

                    <ListItem button onClick={() => handleMenuClick(0)}>
                        <ListItemIcon><DashboardIcon />
                        </ListItemIcon> <ListItemText primary="Dashboard" />
                    </ListItem>

                    {/* Lançamentos com colapso */}
                    <ListItem button onClick={handleLancamentosClick}>
                        <ListItemIcon>
                            <ReceiptLongIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Lançamentos" />
                        {openLancamentos ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>

                    <Collapse in={openLancamentos} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                            {
                                (

                                    (regra.includes("ADMIN_CONTAS_A_RECEBER") && regra.includes("ADMIN_CONTAS_A_PAGAR"))

                                ) &&
                                <ListItem button sx={{ pl: 4 }} onClick={() => handleMenuClick(1)}>
                                    <ListItemIcon>
                                        <DashboardIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Visão Geral" />
                                </ListItem>
                            }

                            {
                                (
                                    regra.includes("ADMIN_CONTAS_A_RECEBER")

                                ) &&
                                <ListItem button sx={{ pl: 4 }} onClick={() => handleMenuClick(11)}>
                                    <ListItemIcon>
                                        <AccountBalanceWalletIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Contas a Receber" />
                                </ListItem>

                            }

                            {
                                (
                                    regra.includes("ADMIN_CONTAS_A_PAGAR")

                                ) &&
                                <ListItem button sx={{ pl: 4 }} onClick={() => handleMenuClick(12)}>
                                    <ListItemIcon>
                                        <RequestQuoteIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Contas a Pagar" />
                                </ListItem>
                            }
                        </List>
                    </Collapse>

                    {
                        (

                            (regra.includes("ADMIN_FLUXO_CAIXA"))

                        ) &&
                        <ListItem button onClick={() => handleMenuClick(2)}>
                            <ListItemIcon>
                                <PaymentsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="Fluxo de Caixa" />
                        </ListItem>
                    }

                    {
                        (

                            (regra.includes("ADMIN"))

                        ) &&
                        <ListItem button onClick={() => handleMenuClick(3)}>
                            <ListItemIcon>
                                <RequestQuoteIcon sx={{ color: 'orange' }} />
                            </ListItemIcon>
                            <ListItemText primary="Parcelas" />
                        </ListItem>
                    }



                    {
                        (

                            (regra.includes("ADMIN_TABELAS_AUXILIARES"))

                        ) &&
                        <ListItemButton onClick={handleClickAux}>
                            <ListItemIcon>
                                <SettingsIcon />
                            </ListItemIcon>
                            <ListItemText primary="Tabelas Auxiliares" />
                        </ListItemButton>
                    }
                    {
                        (

                            (regra.includes("ADMIN_TABELAS_AUXILIARES"))

                        ) &&

                        <Menu anchorEl={anchorEl2} open={open2} onClose={handleClose2}>
                            <MenuItem onClick={() => handleMenuClick(10)}>Métodos de Pagamento</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(20)}>Condições de Pagamento</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(30)}>Grupo de Contas</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(40)}>Contas</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(50)}>Instituições Bancárias</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(60)}>Taxas e Aliquotas</MenuItem>
                        </Menu>
                    }



                    <ListItem>
                        <ListItemIcon>  <PostAddIcon /> </ListItemIcon>
                        <ListItemText primary="Relatoria(em breve)" />
                    </ListItem>
                </List>
            </Drawer>




        </div >
    );
}



